import { CancelToken } from 'axios'

import { portalApi } from '@/axios'

import { Beneficiary } from '@/classes/models'

export default class BeneficiaryService {
  /**
   * Get beneficiaries based on context.
   *
   * @param {Context} context
   * @param {PaginationRequest} parameters
   *
   * @return {Promise}
   */
  static getAll (context, parameters) {
    const cancelToken = CancelToken.source()

    let request = portalApi.get(this.endpoint(context), {
      cancelToken: cancelToken.token,
      params: parameters ? parameters.getParams() : null
    }).then(response => {
      return response.data
    })

    request.then(response => {
      // Set pagination
      response.totalCount = response.numberOfResults

      // Map to Beneficiary
      response.data = response.results.map(user => {
        return new Beneficiary(user)
      })

      return response
    }).catch(error => {
      return Promise.reject(error)
    })

    return { request, cancelToken }
  }

  /**
   * Get a transaction by id.
   *
   * @param {Context} context
   * @param {string} beneficiaryId
   *
   * @return {Promise}
   */
  static get (context, beneficiaryId) {
    return portalApi.get(`${this.endpoint(context)}/${beneficiaryId}`).then(response => {
      return response.data
    }).then(response => {
      // Map to Beneficiary
      return new Beneficiary(response)
    }).catch(error => {
      return Promise.reject(error)
    })
  }

  /**
   * Create a beneficiary
   *
   * @param {Context} context
   * @param {Object} data
   *
   * @return {Promise}
   */
  static add (context, data) {
    return portalApi.post(this.endpoint(context), data)
  }

  /**
   * Update a beneficiary status
   *
   * @param {Context} context
   * @param {string} beneficiaryId
   * @param {Object} data
   *
   * @return {Promise}
   */
  static updateStatus (context, beneficiaryId, data) {
    return portalApi.put(`${this.endpoint(context)}/${beneficiaryId}/status`, data)
  }

  /**
   * Endpoint of API.
   *
   * @param {Context} context
   *
   * @return {string}
   */
  static endpoint (context) {
    return `${context.endpoint(['business'])}/beneficiaries`
  }
}
